// extracted by mini-css-extract-plugin
export default {"wrapper":"Detail_wrapper__eDU4p","headerActions":"Detail_headerActions__oYUta","title":"Detail_title__MvQ0N"};